import { render, staticRenderFns } from "./ContainerNew.vue?vue&type=template&id=5dd897d1&"
import script from "./ContainerNew.vue?vue&type=script&lang=js&"
export * from "./ContainerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports